const autofocusDirective = {
    mounted(el: HTMLElement, binding) {
        if (binding.value || binding.value === undefined) {
            el.focus();
        }
    },
};

export default autofocusDirective;
